<mat-form-field class="app-nature-select" appearance="outline">
  <mat-label>Naturaleza</mat-label>
  <mat-select [formControl]="natureFormControl">
    @for (option of natureOptions; track $index) {
    <mat-option [value]="option.value"> {{ option.label }} </mat-option>
    }
  </mat-select>
</mat-form-field>
